import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import './index.css';

function Exception403() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // 返回上一页
  };

  const handleGoHome = () => {
    navigate('/dash'); // 返回首页
  };

  return (
    <Result
    style={{margin: 100}}
      status="403"
      title="403"
      subTitle="Sorry, you are not authorized to access this page."
      extra={
        <>
          <Button type="default" onClick={handleGoBack}>Go Back</Button>
          <Button type="primary" onClick={handleGoHome}>Back Home</Button>
        </>
    }
    />
  );
}

export default Exception403;
